import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Stack,
  Typography,
} from "@mui/material";
import type { FC } from "react";

interface Tag {
  readonly category: string;
  readonly value: string;
}

interface TagGroupProps {
  readonly category: string;
  readonly tags: string[];
  readonly selectedTags: Tag[];
  readonly onSelect: (tag: Tag) => void;
  readonly onUnselect: (tag: Tag) => void;
}

const TagGroup: FC<TagGroupProps> = ({ category, tags, selectedTags, onSelect, onUnselect }) => (
  <Stack key={category} direction="column">
    <Typography variant="subtitle2">{category}</Typography>
    <FormGroup>
      {tags.map((t) => (
        <FormControlLabel
          key={t}
          control={
            <Checkbox
              checked={!!selectedTags.find((st) => st.category === category && st.value === t)}
              size="small"
              onChange={(_, checked) =>
                checked ? onSelect({ category, value: t }) : onUnselect({ category, value: t })
              }
            />
          }
          label={t}
          slotProps={{ typography: { variant: "body2" } }}
        />
      ))}
    </FormGroup>
  </Stack>
);

export interface PublicPackagesSearchCriteria {
  readonly tags: Tag[];
}

interface Props {
  readonly value: PublicPackagesSearchCriteria;
  readonly tagsByCategory: Record<string, string[]>;
  readonly onChange: (value: PublicPackagesSearchCriteria) => void;
}

const PublicPackagesSearch: FC<Props> = ({ value, tagsByCategory, onChange }) => {
  return (
    <Box
      sx={{
        overflow: "auto",
      }}
    >
      <Card>
        <CardHeader subheader="Filtruj według" />
        <CardContent>
          <Stack
            direction="column"
            spacing={2}
            sx={{
              alignItems: "stretch",
            }}
          >
            {Object.entries(tagsByCategory).map(([category, tags]) => (
              <TagGroup
                key={category}
                category={category}
                tags={tags}
                selectedTags={value.tags}
                onSelect={(t) => onChange({ tags: [...value.tags, t] })}
                onUnselect={(t) =>
                  onChange({ tags: value.tags.filter((st) => st.category !== t.category || st.value !== t.value) })
                }
              />
            ))}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PublicPackagesSearch;
